import { render, staticRenderFns } from "./UserOffers.vue?vue&type=template&id=2a6464dd&"
import script from "./UserOffers.vue?vue&type=script&lang=js&"
export * from "./UserOffers.vue?vue&type=script&lang=js&"
import style0 from "./UserOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserOffers.vue"
export default component.exports